//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const columns = [
    { name: 'name', label: '产品', field: 'parts_name', required: true },
    { name: 'take', label: '带机', field: 'is_take_machine' },
    { name: 'num', label: '数量', field: 'num' },
    { name: 'price', label: '单价', field: 'parts_price' },
    { name: 'totalPrice', label: '总价', field: 'total_price' }
]

const ocolumns = [
    { name: 'title', label: '产品信息', field: 'title' },
    { name: 'name', label: '用户', field: 'name' },
    { name: 'mobile', label: '电话', field: 'mobile' },
    { name: 'channel', label: '渠道', field: 'channel' },
    { name: 'salesman', label: '业务员', field: 'salesman' },
    { name: 'number', label: '单号', field: 'number' },
]

export default {
    name: 'OrderDetail',

    data() {
        return {
            showNewUser:false,
            showProject:false,
            enId: '',
            data: {},
            productData:[],
            relOrdersData:[],
            productColumns:columns,
            orderColumns:ocolumns
        }
    },
    mounted() {
        var that = this
        let enId = this.$route.params.enId
        this.enId = enId
        this.$axios
            .get('/api/beijing/productOrder/detailAjax?enId=' + enId)
            .then(function (response) {
                that.loading = false
                let data = response.data.data;
                console.log(data)
                that.data = data
                that.productData = data.orderList
                that.relOrdersData = data.relOrders
                
                var type = data['type'];
                if(type==2||type==20||type==21){
                    that.showNewUser = true
                }
                if(type==10){
                    that.showProject = true
                }
            })
            .catch(function (error) { // 请求失败处理
                that.loading = false
                console.log(error);
            });
    },
    computed: {
        title() {
            return this.$route.meta && this.$route.meta.title
        }
    }
}
